<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    count?: number;
    isReactedByMe?: boolean;
    reaction?: string;
    readOnly?: boolean;
  }>(),
  {
    readOnly: false,
  },
);

const validImage = computed(() => {
  return props.reaction !== undefined;
});
</script>

<template>
  <div
    class="m-comment-reaction"
    v-if="validImage"
    :class="{
      'm-reacted': isReactedByMe,
      'read-only': readOnly,
    }"
  >
    <div class="reaction-emoji">
      {{ reaction }}
    </div>
    <div
      class="m-reaction-count"
      :class="isReactedByMe ? 'c-title-bold--s' : 'c-text-regular--s'"
    >
      {{ count }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-comment-reaction {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff;
  border-radius: 4px;
  padding: 1px 6px 1px 4px;
  border: 1px solid $color-gray400;
  box-sizing: border-box;
  cursor: pointer;
  &:not(.read-only):hover {
    border: 1px solid $color-gray600;
  }

  .m-reaction-count {
    line-height: 18px;
  }
  .reaction-emoji {
    margin-right: 2px;
    font-size: 14px;
    font-family: $emoji-font-family;
  }
}
.m-reacted {
  border: 1px solid $color-green400;
  background: $color-green100;
  color: $color-green400;
  &:hover {
    border: 1px solid $color-green400;
  }
}
</style>
